import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  const failures = ['Los cursos importados usan ingredientes que suben de precio cada viernes, destruyendo tu margen de ganancia en horas.', 'Intentar ahorrar comprando lo más barato sin técnica termina en postres secos o sin sabor que el cliente no vuelve a comprar.', 'Publicar "hago tortas" en tus estados de WhatsApp y esperar a que la gente pregunte no es un plan de ventas, es una moneda al aire.', 'Ignorar los gastos invisibles como el jabón, el desgaste de los moldes y el transporte al mercado.'];
  return <section className="py-16 px-6 bg-cream-dark" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-111">
          <div className="flex items-center gap-4 mb-6" data-id="element-112">
            <TrendingDownIcon className="w-8 h-8 text-danger" data-id="element-113" />
            <h2 className="text-3xl md:text-4xl font-bold" data-id="element-114">
              El Problema del "Ojímetro"
            </h2>
          </div>

          <div className="space-y-6 text-lg text-chocolate/90" data-id="element-115">
            <p data-id="element-116">
              El error número uno del emprendedor casero es el "Ojímetro".
              Multiplicar el costo de la harina por tres no paga la luz, el gas,
              los envases, ni mucho menos tu tiempo. Si no sabes exactamente
              cuánto te cuesta cada gramo de azúcar, no tienes un negocio,
              tienes un hobby que te está quitando dinero.
            </p>
            <p data-id="element-117">
              Además, la mayoría de los cursos que ves en internet están
              diseñados para otros países. Te piden mantequilla de alta gama,
              extractos puros y harinas especiales que aquí cuestan una fortuna
              o simplemente no se consiguen, haciendo que tus postres sean
              impagables para tus vecinos.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-10 rounded-3xl shadow-warm" data-id="element-118">
          <h3 className="text-2xl font-bold mb-8 text-chocolate-dark border-b border-cream-dark pb-4" data-id="element-119">
            Por qué lo que has intentado no funcionó:
          </h3>

          <ul className="space-y-6" data-id="element-120">
            {failures.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-121">
                <div className="mt-1 bg-danger/10 p-1 rounded-full shrink-0" data-id="element-122">
                  <XIcon className="w-5 h-5 text-danger" data-id="element-123" />
                </div>
                <span className="text-lg text-chocolate/80 leading-relaxed" data-id="element-124">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}